import React from 'react';

const SvgBm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path
        d="M0 3.333V0h5.333v3.333c0 2-2.666 3.334-2.666 3.334S0 5.333 0 3.333z"
        id="BM_svg__c"
      />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="BM_svg__e">
        <stop stopColor="#E20B0C" offset="0%" />
        <stop stopColor="#D40001" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="BM_svg__f">
        <stop stopColor="#DB1E36" offset="0%" />
        <stop stopColor="#D51931" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BM_svg__b" fill="#fff">
        <use xlinkHref="#BM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BM_svg__a" />
      <path fill="#DC1F37" mask="url(#BM_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#042C90" mask="url(#BM_svg__b)" d="M0 0h12v9.333H0z" />
      <g mask="url(#BM_svg__b)">
        <g transform="translate(17.333 6.667)">
          <mask id="BM_svg__d" fill="#fff">
            <use xlinkHref="#BM_svg__c" />
          </mask>
          <use fill="#FFF" xlinkHref="#BM_svg__c" />
          <circle
            fill="#65B5D2"
            mask="url(#BM_svg__d)"
            cx={2.667}
            cy={4}
            r={1.333}
          />
          <path
            d="M2.667 2.667a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zM1.333 4a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM4 4a.667.667 0 1 1 0-1.333A.667.667 0 0 1 4 4z"
            fill="url(#BM_svg__e)"
            mask="url(#BM_svg__d)"
          />
          <path
            fill="#2F8F22"
            mask="url(#BM_svg__d)"
            d="M0 5.333h5.333v1.333H0z"
          />
        </g>
      </g>
      <path
        d="M4.333 4.153L-.9-.333H.667l.193.062L5.44 3h1.131l5.762-3.601v.934c0 .296-.17.627-.417.803l-4.25 3.036V5.18l4.3 3.685c.377.323.185.802-.3.802-.257 0-.588-.107-.804-.261L6.56 6.333H5.429L-.333 9.935v-1.44l4.666-3.333V4.153z"
        stroke="#FFF"
        strokeWidth={0.667}
        fill="#DB1E36"
        mask="url(#BM_svg__b)"
      />
      <path
        d="M0 3.333V6h4.667v3.34c0 .364.306.66.673.66h1.32a.67.67 0 0 0 .673-.66V6h4.658a.677.677 0 0 0 .676-.673v-1.32a.674.674 0 0 0-.676-.674H7.333V0H4.667v3.333H0z"
        fill="#FFF"
        mask="url(#BM_svg__b)"
      />
      <path
        fill="url(#BM_svg__f)"
        mask="url(#BM_svg__b)"
        d="M0 4h5.333V0h1.334v4H12v1.333H6.667v4H5.333v-4H0z"
      />
    </g>
  </svg>
);

export default SvgBm;
